import { render, staticRenderFns } from "./goodsNameTag.vue?vue&type=template&id=953f4e70&scoped=true"
import script from "./goodsNameTag.vue?vue&type=script&lang=js"
export * from "./goodsNameTag.vue?vue&type=script&lang=js"
import style0 from "./goodsNameTag.vue?vue&type=style&index=0&id=953f4e70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953f4e70",
  null
  
)

export default component.exports